import {
  getAllAdminsAPI,
  getAdminAPI,
  deleteAdminAPI,
  createAdminAPI
} from './apis'
import *  as commonActions from "../../common/actions"
import { errorMessage } from '../../../utils'

export const GET_ALL_ADMINS_REQUEST = 'GET_ALL_ADMINS_REQUEST';
export const GET_ALL_ADMINS_SUCCESS = 'GET_ALL_ADMINS_SUCCESS';
export const GET_ALL_ADMINS_FAILED = 'GET_ALL_ADMINS_FAILED';

export const getAllAdmins = (filters) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: GET_ALL_ADMINS_REQUEST })
    getAllAdminsAPI(filters).then(res => {
      dispatch({
        type: GET_ALL_ADMINS_SUCCESS,
        payload: res
      })
      return resolve(res)
    }).catch(err => {
      dispatch({ type: GET_ALL_ADMINS_FAILED })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const GET_ADMIN_BY_ID_REQUEST = 'GET_ADMIN_BY_ID_REQUEST';
export const GET_ADMIN_BY_ID_SUCCESS = 'GET_ADMIN_BY_ID_SUCCESS';
export const GET_ADMIN_BY_ID_FAILED = 'GET_ADMIN_BY_ID_FAILED';

export const getAdmin = id => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: GET_ADMIN_BY_ID_REQUEST })
    getAdminAPI(id).then(res => {
      dispatch({
        type: GET_ADMIN_BY_ID_SUCCESS,
        payload: res && res.info,
      })
      return resolve(res)
    }).catch(err => {
      dispatch({ type: GET_ADMIN_BY_ID_FAILED })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST';
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS';
export const DELETE_ADMIN_FAILED = 'DELETE_ADMIN_FAILED';

export const deleteAdmin = (id) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: DELETE_ADMIN_REQUEST })
    deleteAdminAPI(id).then(res => {
      dispatch({ type: DELETE_ADMIN_SUCCESS, payload: res })
      dispatch(commonActions.openSnackbarsState({ message: res && res.message }))
      return resolve(res)
    }).catch(err => {
      dispatch({ type: DELETE_ADMIN_FAILED })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const UPDATE_ADMIN_REQUEST = 'UPDATE_ADMIN_REQUEST';
export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_FAILED = 'UPDATE_ADMIN_FAILED';

export const updateAdmin = (data) => dispatch =>
  new Promise((resolve, reject) => {
    dispatch({ type: UPDATE_ADMIN_REQUEST })
    createAdminAPI(data).then(res => {
      dispatch({ type: UPDATE_ADMIN_SUCCESS, payload: res })
      dispatch(commonActions.openSnackbarsState({ message: res && res.message }))
      return resolve(res)
    }).catch(err => {
      dispatch({ type: UPDATE_ADMIN_FAILED })
      dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
      return reject(err)
    })
  })

export const CREATE_ADMIN_REQUEST = 'CREATE_ADMIN_REQUEST';
export const CREATE_ADMIN_SUCCESS = 'CREATE_ADMIN_SUCCESS';
export const CREATE_ADMIN_FAILED = 'CREATE_ADMIN_FAILED';

export function createAdmin(data) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({ type: CREATE_ADMIN_REQUEST })
      createAdminAPI(data).then(res => {
        const { info = {} } = res || {}
        dispatch({ type: CREATE_ADMIN_SUCCESS, payload: info || {} })
        dispatch(commonActions.openSnackbarsState({ message: res && res.message }))
        resolve(res)
      }).catch(err => {
        dispatch({ type: CREATE_ADMIN_FAILED })
        dispatch(commonActions.openSnackbarsState({ message: errorMessage(err), messageType: 'error' }))
        reject(err)
      })
    })
  }
}

export const CLEAR_ADMIN_DATA = 'CLEAR_ADMIN_DATA';
export const clearStoreForAdmin = () => dispatch => {
  dispatch({ type: CLEAR_ADMIN_DATA })
}
